export default function Footer() {
  return (
    <footer className="bg-dark-900 text-white py-6 sm:py-8 text-center mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-sm sm:text-base">
          <b>© The Dingocoin Project 2021 - 2025</b>
        </span>
      </div>
    </footer>
  );
}